<template>
  <div
    class="contact-info contact-info__wrapper"
  >
    <a
      :href="$t('meta.content.header.phone')"
      :aria-label="$t('contact.hotline.link.button')"
      class="contact-info__link contact-info__link--tel"
    >
      {{ $t('meta.content.header.phone.string') }}
    </a>
    <a
      v-if="isSuccessLogout"
      :href="`mailto:${$t('contact.mail.vue3')}`"
      :aria-label="$t('contact.mail.link.button')"
      class="contact-info__link contact-info__link--mail"
    >
      {{ $t('contact.mail.label.vue3') }}
    </a>
    <a
      v-else-if="!isContactPage"
      :href="contactUrl"
      :aria-label="$t('contact.contact.link.button')"
      class="contact-info__link contact-info__link--mail"
    >
      {{ $t('contact.contact.page.label') }}
    </a>
    <a
      v-else
      :href="`mailto:${$t('contact.mail.vue3')}`"
      :aria-label="$t('contact.mail.link.button')"
      class="contact-info__link contact-info__link--mail"
    >
      {{ $t('contact.mail.label.vue3') }}
    </a>
  </div>
</template>

<script>

  export default {
    props: {
      contactUrl: String,
      isContactPage: {
        type: Boolean,
        default: false
      },
      isSuccessLogout: {
        type: Boolean,
        default: false
      },
    },
  };

</script>
